import React from 'react'
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import { parseYearPickerValue, toYearPickerDate } from "../../app/helpers/yearPickerHelper";

const EditYearGeneric = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation }) => {
    
    const { t } = useTranslation();
    const selectedYear = parseYearPickerValue(values[field]);
    
    return (
        <div className={`col-md-${occupation}`}>
            <label htmlFor="name" className="form-label tit-view">
            {t(`${moduleText}.short.${field}`)}
            </label>
            <DatePicker
                showYearPicker
                dateFormat="yyyy"
                
                className={`form-control txt-view ${errors[field] && "border border-danger"}`}
                
                selected={selectedYear}
                
                onChange={(event) => handleChange(toYearPickerDate(event), field )}
                id={field}
                name={field}
                
                required
                autoComplete="off"
                placeholderText={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
            />
            {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
        </div>
    )
}

export default EditYearGeneric
